<template>
  <a-modal class="modal-content" :destroyOnClose="true"  :width="'50%'" v-model="updateSms" :title="$t('org.rechargeSms')" @ok="handleOk">
    <a-radio-group  style="padding:20px;" :options="updateType" @change="onTypeChange" defaultValue="add" />
    <div style="padding:20px;">
      <span>{{$t('org.smsLabel', {text: type === 'add' ? $t('org.topUp') : $t('org.recycle')}) + ':'}}</span>
      <a-input-number style="margin-left: 20px;"  :min="0" :max="100000" :step="1000" v-model.number="userMessageNum" />
    </div>
  </a-modal>
</template>

<script>
  import config from '../../config/'
  import checkTypes from '../../utils/checkDataType'
  // import {mapGetters} from 'vuex'
  export default {
    name: 'ZUpdateOrgSms',
    data() {
      return {
        updateSms: false,
        userMessageNum: 0,
        orgId: '',
        // updateType: [
        //   {
        //     label: '充值', value: 'add'
        //   },
        //   {
        //     label: '回收', value: 'dec'
        //   }
        // ],
        type: 'add'
      }
    },
    computed: {
      updateType () {
        return [
          {
            label: this.$t('org.topUp'), value: 'add'
          },
          {
            label: this.$t('org.recycle'), value: 'dec'
          }
        ]
      }
    },
    methods: {
      handleOk() {
        if (this.userMessageNum && checkTypes.isNumber(this.userMessageNum)) {
          // todo
          let number = this.type === 'add' ? this.userMessageNum : `-${this.userMessageNum}`
          // console.log(number)
          this.$http.put(config.api.modify_org_sms_num + `${this.orgId}/${number}`).then((res) => {
            // console.log(res)
            if (res.code === 0) {
              this.userMessageNum = 0
              this.$emit("updateSuccess", this.orgId)
              this.$message.success(this.$t('org.rechargeSuccess'))
              this.updateSms = false
            } else {
              this.$message.error(res.desc)
            }
          })
        } else {
          // 输入不合法或者为0
          this.$message.info(this.$t('org.errData'))
        }
        
      },
      onTypeChange (e) {
        if (e.target.value) {
          // ..
          this.type = e.target.value
          // console.log(this.type)
        }
      },
      showModel(orgId) {
        this.updateSms = true
        this.orgId = orgId
        this.type = 'add'
      }
    }
  }
</script>